export default __webpack_public_path__ + "static/media/save.95062533.svg";